import React from "react";
import './InfoLaw.css';

class InfoLaw extends React.Component{
    render() {
        return (
            <div>
                <h2>Заголовок</h2>
                <p>Национа́льный банк Украи́ны (НБУ) (укр. Національний банк України) — центральный банк Украины. Находится в одноимённом здании по адресу: Киев, ул. Институтская, 9.</p>

            <p>Национальный банк Украины был создан на основе Украинского республиканского банка Государственного банка СССР вместе с принятием 20 марта 1991 года Верховной Радой Закона Украины «О банках и банковской деятельности». В начале 90-х годов Украина столкнулась с высокой инфляцией (10 200 % в год) и неприспособленностью денежной системы к рыночным условиям, и на протяжении 1994—1996 годов подготовлена и проведена денежная реформа, которая изменила в лучшую сторону всю систему денежного обращения Украины. Была восстановлена историческая денежная единица — украинская гривна, а гиперинфляция и спад в производстве были преодолены.</p>
            </div>
        );
    }
}
export default InfoLaw;